<template>
  <v-main>
    <v-container fluid>
      <v-row align="center" justify="center">
        <v-col class="text-center" cols="12" sm="4">
          <h3>Select Type of Play</h3>
          <br>
          <v-btn-toggle v-model="toggle_none">
            <v-btn value="left" @click="playOption(false)">
              <span class="hidden-sm-and-down">Individual</span>
              <v-icon right>mdi-account</v-icon>
            </v-btn>
            <v-btn :disabled="!this.groupPlayAvailable" value="center" @click="playOption(true)">
              <span class="hidden-sm-and-down">Group</span>
              <v-icon right>mdi-account-multiple</v-icon>
            </v-btn>
          </v-btn-toggle>
        </v-col>
      </v-row>
    </v-container>
  </v-main>
</template>

<script>
export default {
  data() {
    return {
      text: "center",
      icon: "justify",
      toggle_none: null,
      toggle_one: 0,
      toggle_exclusive: 2,
      toggle_multiple: [0, 1, 2]
    };
  },
  computed: {
    groupPlayAvailable() {
      return this.$store.getters.currentGame.open;
    }
  },
  methods: {
    playOption(x) {
      this.$store.dispatch("groupPlay", x);
      this.$store.dispatch("tabulateResults");
      this.$router.push("/selectfunds");
    }
  }
};
</script>
